module.exports = __webpack_public_path__ + "static/media/EMT_Stock Market.56ac68d7.png";